enum Page {
  ApplicationSpecific,
  Error,
  Landing,
}

export default Page;
